import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/auth/AuthCallback";

// Lazy routes: /ads and /admin never download the full sales page's chunk.
const ContentPage = lazy(() => import("@/pages/ContentPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const PreviewPage = lazy(() => import("@/pages/PreviewPage"));

function AppRouter() {
  const location = useLocation();
  // Google Auth returns here with #session_id=... — handle it before routes.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<ContentPage variant="main" />} />
        <Route path="/ads" element={<ContentPage variant="ads" />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/preview/ads" element={<PreviewPage ads />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
